import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Botones from "../Componentes/Botones";
import BotonEncuesta from "../Componentes/BotonEncuesta";
import BotonMetroMinuto from "../Componentes/BotonMetroMinuto";
import BotonFCM from "../Componentes/BotonFCM";
import LanguageSwitcher from "../Componentes/LanguageSwitcher";
import { Link } from "react-router-dom";

function useIsMobile(breakpoint = 900) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);
  return isMobile;
}

export const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [recursosOpen, setRecursosOpen] = useState(false);
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  // Cierra menú al seleccionar opción
  const handleLinkClick = () => {
    closeMenu();
    setRecursosOpen(false);
  };

  return (
    <nav
      style={{
        background: "#fff",
        border: "none",
        position: "sticky",
        top: "80px",
        zIndex: 199,
        minHeight: "68px",
        boxShadow: "0 2px 8px 0 rgba(0,0,0,0.03)",
      }}
    >
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          padding: 0,
          position: "relative",
          minHeight: "68px",
        }}
      >
        {/* Botón hamburguesa SOLO en móvil */}
        {isMobile && (
          <button
            type="button"
            onClick={toggleMenu}
            style={{
              background: "#fff",
              border: "1.5px solid #aaa",
              borderRadius: 7,
              padding: 10,
              margin: 18,
              position: "sticky",
              top: 0,
              right: 0,
              zIndex: 2001,
            }}
            aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}
          >
            {menuOpen ? (
              <span
                style={{
                  display: "block",
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#23272b",
                  width: 28,
                  height: 28,
                  lineHeight: "28px",
                }}
              >
                &times;
              </span>
            ) : (
              <>
                <span
                  style={{
                    display: "block",
                    width: 24,
                    height: 3,
                    background: "#222",
                    margin: "4px 0",
                  }}
                />
                <span
                  style={{
                    display: "block",
                    width: 24,
                    height: 3,
                    background: "#222",
                    margin: "4px 0",
                  }}
                />
                <span
                  style={{
                    display: "block",
                    width: 24,
                    height: 3,
                    background: "#222",
                    margin: "4px 0",
                  }}
                />
              </>
            )}
          </button>
        )}

        {/* Menú móvil */}
        {isMobile && menuOpen && (
          <div
            style={{
              position: "sticky",
              left: 0,
              top: "100%",
              width: "100vw",
              background: "#23272b",
              zIndex: 2000,
              boxShadow: "0 6px 24px rgba(0,0,0,0.14)",
              transition: "all 0.3s",
            }}
          >
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: "16px 0",
                display: "flex",
                flexDirection: "column",
                fontSize: "1.15rem",
              }}
            >
              <li>
                <a href="/" style={menuMobileStyle} onClick={handleLinkClick}>
                  {t("BotonesNav.proyecto")}
                </a>
              </li>
              <li>
                <button
                  onClick={() => setRecursosOpen((r) => !r)}
                  style={{
                    ...menuMobileStyle,
                    background: "none",
                    border: "none",
                    width: "100%",
                    textAlign: "left",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  {t("BotonesNav.recursos")}
                </button>
                {recursosOpen && (
                  <ul style={{ paddingLeft: 24, background: "#23272b" }}>
                    <li>
                      <a
                        className="page-scroll"
                        style={menuMobileStyle}
                        onClick={handleLinkClick}
                      >
                        <BotonEncuesta />
                      </a>
                    </li>
                    <li>
                      <a
                        className="page-scroll"
                        style={menuMobileStyle}
                        onClick={handleLinkClick}
                      >
                        <BotonMetroMinuto />
                      </a>
                    </li>
                    <li>
                      <a
                        className="page-scroll"
                        style={menuMobileStyle}
                        onClick={handleLinkClick}
                      >
                        <BotonFCM />
                      </a>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <Link
                  to="/services"
                  style={menuMobileStyle}
                  onClick={handleLinkClick}
                >
                  {t("BotonesNav.publicaciones")}
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  style={menuMobileStyle}
                  onClick={handleLinkClick}
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/team"
                  style={menuMobileStyle}
                  onClick={handleLinkClick}
                >
                  {t("BotonesNav.equipo")}
                </Link>
              </li>
              <li>
                <a
                  href="#footer"
                  style={menuMobileStyle}
                  onClick={handleLinkClick}
                >
                  {t("BotonesNav.contacto")}
                </a>
              </li>
            </ul>
          </div>
        )}

        {/* Menú de escritorio */}
        {!isMobile && (
          <ul
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
              gap: "36px",
              margin: 0,
              padding: "0 140px 0 0",
              listStyle: "none",
              height: "68px",
              minHeight: "68px",
            }}
          >
            <li>
              <a href="/" style={{ padding: "0px 22px" }}>
                <Botones>{t("BotonesNav.proyecto")}</Botones>
              </a>
            </li>
            <li style={{ position: "relative" }}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setRecursosOpen((r) => !r);
                }}
              >
                <Botones>{t("BotonesNav.recursos")}</Botones>
              </a>
              {recursosOpen && (
                <ul
                  style={{
                    position: "absolute",
                    top: "4rem",
                    left: 0,
                    minWidth: "190px",
                    background: "#fff",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.09)",
                    padding: "12px 0",
                    margin: 0,
                    borderRadius: "0 0 7px 7px",
                    border: "1px solid #eee",
                    zIndex: 999,
                  }}
                >
                  <li>
                    <a style={{ display: "block", padding: "8px 22px" }}>
                      <BotonEncuesta />
                    </a>
                  </li>
                  <li>
                    <a style={{ display: "block", padding: "8px 22px" }}>
                      <BotonMetroMinuto />
                    </a>
                  </li>
                  <li>
                    <a style={{ display: "block", padding: "8px 22px" }}>
                      <BotonFCM />
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link to="/services">
                <Botones>{t("BotonesNav.publicaciones")}</Botones>
              </Link>
            </li>
            <li>
              <Link to="/team">
                <Botones>{t("BotonesNav.equipo")}</Botones>
              </Link>
            </li>
            <li>
              <Link to="/blog">
                <Botones>Blog</Botones>
              </Link>
            </li>
            <li>
              <a href="#footer">
                <Botones>{t("BotonesNav.contacto")}</Botones>
              </a>
            </li>
          </ul>
        )}

        {/* Integración del selector de idioma */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "18px",
            transform: "translateY(-50%)",
            zIndex: 2002,
          }}
        >
          <LanguageSwitcher />
        </div>
      </div>
    </nav>
  );
};

const menuMobileStyle = {
  color: "#fff",
  fontWeight: 700,
  fontSize: "1.23rem",
  padding: "20px 32px",
  textTransform: "uppercase",
  letterSpacing: "0.09em",
  borderBottom: "1px solid #35383d",
  textDecoration: "none",
  width: "100%",
  display: "block",
  background: "none",
};

export default Navigation;
